import type { Article } from "@/types";

// No sample articles — content comes from Firebase
export const sampleArticles: Article[] = [];
